// components/AddonModal.js
import React, { useState, useEffect } from 'react';
import Loader from './Loader';
import { toast } from 'react-toastify';
import ApiService from '../services/ApiService';
import { Dropdown } from "primereact/dropdown";
import {  useSearchParams } from 'react-router-dom';


const AddonModal = ({ branchId, closeModal }) => {

    const [addons, setAddons] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const [apiData, setApiData] = useState({
      "addon_id": "",
      "item_id": searchParams.get('item_id') || "",
    });

    useEffect(() => {
        getAddons();
    }, []);

    const getAddons = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "addons-list", // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                setAddons(data.data);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoader(true);
    
        try {
    
          const response = await ApiService.request({
            method: 'POST',
            url: `addons/addNewItemToAddon`, // Replace with your API endpoint
            data:apiData,
          });
    
          if (response.data.status) {
            toast.success(response.data.message);
            closeModal();
          } else {
            toast.error(response.data.message);
          }
          setIsLoader(false);
        } catch (error) {
          console.error('Form submission failed:', error);
        } finally {
          setIsLoader(false);
        }
    };
     

    return (
        <div>
            <div className="backdrop"></div>
            <div
                className="modal fade show" style={{ display: 'block'}}
                id="exampleModalLive"
                tabindex="-1"
                aria-labelledby="exampleModalLiveLabel"
                aria-modal="true"
                role="dialog"
            >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                <div className="modal-header">
                    <h4>Existing Modifiers</h4>
                </div>

                <form onSubmit={handleSubmit} method="post" >
                    <div className="modal-body">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="required fs-6 fw-semibold mb-2">Modifier</label>
                        {/* <select name="addon_id" className='form-select' 
                          onChange={(e) =>
                            setApiData({ ...apiData, addon_id: e.target.value })
                          }>
                          <option value="">Select Modifier</option>
                          {addons.map((addon, index) => (
                            <option value={addon._id}>{addon.title}</option>
                          ))}
                        </select> */}
                         <Dropdown
                          value={apiData.addon_id}
                          options={addons}
                          optionLabel="title" 
                          optionValue="_id" 
                          onChange={(selectedOption) =>
                            setApiData({ ...apiData, addon_id: selectedOption.value })
                          }
                          placeholder="Select Modifier"
                          filter
                          checkmark={true}
                        /> 
                        
                      </div>
                       
                    </div>
                    <div className="modal-footer">
                        <button type="button" onClick={closeModal} className="btn btn-light me-3"
                        >Close</button>
                        <button duration="submit" className="btn btn-base" disabled={isLoader}>
                            <span className="indicator-label">{isLoader ? <Loader size="20" color="white" text="Submitting" /> : ('Submit')}</span>
                        </button>
                    </div>
                </form>

                </div>
            </div>
            </div>
        </div>
    );

};



export default AddonModal;
